import React, { useState } from "react";
import {  FaUserMd, FaMinus, FaPlus, FaFileMedical, FaShieldAlt, FaUsers, FaHeartbeat, FaHospitalUser, FaChartLine, FaMicroscope, FaNotesMedical, FaCogs, FaDna, FaLaptopMedical, FaCapsules, FaBrain, FaRobot } from "react-icons/fa";

import Medpalm from "../../../assests/Healthcaretechnology/AI&Machine.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        title: "AI-Powered Diagnostics",
        description:
          "AI-driven diagnostic systems use machine learning algorithms to analyze medical images, pathology slides, and radiology scans with high accuracy. These technologies assist radiologists and pathologists in detecting conditions such as cancer, fractures, and neurological disorders at an early stage. By reducing diagnostic errors and improving speed, AI-powered diagnostics enhance clinical decision-making and patient outcomes."
      },
      {
        title: "Predictive Healthcare Analytics",
        description:
          "Predictive analytics utilizes AI to analyze vast amounts of historical and real-time health data to identify patterns in disease outbreaks, patient deterioration, and treatment outcomes. Hospitals use predictive models to allocate resources efficiently, prevent readmissions, and provide early interventions for high-risk patients. This approach enhances public health strategies and personalized care plans."
      },
      {
        title: "Robotic Surgery",
        description:
          "AI-assisted robotic surgery enhances precision, flexibility, and control in minimally invasive procedures. These robotic systems provide real-time data and high-definition visuals to surgeons, reducing the risk of human error. Robotic-assisted techniques improve patient safety, decrease recovery times, and enable complex surgeries with greater accuracy, particularly in areas like neurosurgery, cardiac surgery, and orthopedic procedures."
      },
      {
        title: "Personalized Medicine",
        description:
          "AI-driven personalized medicine leverages genetic, lifestyle, and medical history data to tailor treatments to individual patients. By analyzing genomic information and biomarker data, AI helps determine the most effective therapies, minimizing adverse reactions and improving treatment efficacy. This approach is transforming fields like oncology, where targeted therapies are crucial for patient survival."
      },
      {
        title: "Virtual Health Assistants",
        description:
          "AI-powered virtual health assistants provide 24/7 support for patients by answering medical queries, scheduling appointments, and offering symptom assessments. These chatbots and voice-enabled assistants integrate with EHR systems to provide personalized health recommendations. They enhance patient engagement, reduce administrative workload, and improve access to healthcare, especially in remote areas."
      },
      {
        title: "AI-Driven Drug Discovery",
        description:
          "AI accelerates the drug discovery process by analyzing molecular structures, predicting potential drug candidates, and optimizing clinical trials. Machine learning models identify promising compounds faster than traditional research methods, reducing costs and time-to-market for new treatments. AI also plays a crucial role in repurposing existing drugs to treat emerging diseases and rare conditions."
      }
    ];
const features = [
    { icon: <FaBrain className="text-[#2a627a] text-lg" />, text: "Use AI algorithms to provide faster, more accurate diagnoses, reducing errors and improving patient care." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Leverage machine learning to analyze trends and predict patient outcomes, enabling early intervention and personalized care plans." },
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Implement AI-powered virtual assistants to assist patients with scheduling, reminders, medication tracking, and real-time healthcare advice." },
    { icon: <FaRobot className="text-[#2a627a] text-lg" />, text: "Automate the processing of clinical data, freeing up time for healthcare professionals to focus on patient care while improving efficiency." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "AI-driven platforms provide customized treatment plans based on individual patient data, improving health outcomes and patient satisfaction." },
    // { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Integration with electronic health records for seamless AI recommendations." }
];

const benefits = [
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "AI and ML technologies enhance diagnostic accuracy, providing earlier and more reliable diagnoses for a wide range of conditions." },
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "AI tools provide real-time insights and decision support, allowing healthcare providers to act quickly and improve patient care." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Automating administrative and clinical processes reduces the burden on healthcare workers, improving overall efficiency and reducing costs." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Personalized care plans and early disease detection improve patient outcomes by enabling timely and targeted treatments." },
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "AI & ML reduce the need for costly tests and procedures by providing more accurate diagnoses and optimizing treatment plans." },
    // { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Optimizes healthcare resources through predictive demand analysis." }
];
const cmsFeatures = [
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "AI Healthcare Specialist – Implements AI/ML algorithms in healthcare systems to enhance diagnostics, optimize patient care, and improve decision-making." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Health IT Specialist – Ensures seamless integration of AI/ML technologies into existing healthcare infrastructure, making it easy for providers to use advanced analytics in patient care." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Data Scientist – Develops and trains models using healthcare data to predict patient outcomes, identify disease trends, and personalize treatments." },
    { icon: <FaUsers className="text-[#2a627a] text-lg" />, text: "AI Research Scientist – Conducts research and develops innovative AI applications to address healthcare challenges, improve patient outcomes, and reduce operational inefficiencies." },
    { icon: <FaCogs className="text-[#2a627a] text-lg" />, text: "Patient Engagement Specialist– Utilizes AI-driven tools to enhance patient engagement through personalized health recommendations and virtual care solutions." },
    // { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Clinical AI Analyst – Interprets AI-generated insights to support medical decision-making." }
]

const Ai = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">AI&Machine - <span className="text-gray-800">Learning in Healthcare</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Leveraging intelligent automation and data-driven insights to enhance diagnostics, optimize treatment, and improve patient outcomes."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is AI & Machine Learning in Healthcare?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        AI & Machine Learning in healthcare involve the use of advanced algorithms and data-driven models to predict, diagnose, and personalize treatment plans for patients. These technologies leverage vast amounts of healthcare data to make real-time decisions, detect patterns, and provide actionable insights that improve clinical outcomes, streamline workflows, and reduce healthcare costs.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in AI&Machine
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                               <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                               <span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

<span className="text-[#2a627a] text-lg">{item.icon}</span>
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Ai;
